@if (configuration.addressGroups?.length > 0) {
<div class="footer-location">
    <div class="footer-section-container">
        @for (group of configuration.addressGroups; track group) {
        <a [attr.href]="group.href">
            <ul class="footer-address">
                <li style="font-weight: bold">{{ group.location }}</li>
                @for (item of group.items; track item) {
                <li>
                    {{ item }}
                </li>
                }
            </ul>
        </a>
        }
    </div>
</div>
}
<div class="footer-content">
    <div class="footer-section-container">
        @if (configuration.logo?.src) {
        <div class="footer-logo">
            @if (!!configuration.logo.href) {
            <a href="{{ configuration.logo.href }}">
                <img
                    src="{{ configuration.logo.src }}"
                    alt="{{ configuration.logo.alt }}"
                />
            </a>
            } @if (!configuration.logo.href) {
            <img
                src="{{ configuration.logo.src }}"
                alt="{{ configuration.logo.alt }}"
            />
            }
        </div>
        }

        <div class="nav-groups">
            @for (group of configuration.navGroups; track group) {
            <div class="footer-nav">
                <div class="title">{{ group.name }}</div>
                <ul>
                    @for (item of group.items; track item) {
                    <li>
                        <ng-container
                            *ngTemplateOutlet="
                                navItem;
                                context: { $implicit: item }
                            "
                        ></ng-container>
                    </li>
                    }
                </ul>
            </div>
            }
        </div>
    </div>
</div>
<div class="footer-bottom-container">
    <div class="footer-section-container">
        <div class="footer-copyright-powered-by">
            @if (configuration.copyright) {
            <span class="copyright" [innerHtml]="getCopyright()"></span>
            } @if (configuration.poweredByLink) {
            <a href="{{ configuration.poweredByLink }}"
                >Powered By
                <img src="{{ configuration.poweredByLogo }}" />
            </a>
            } @if (configuration.poweredByLogo && !configuration.poweredByLink)
            {
            <img src="{{ configuration.poweredByLogo }}" />
            }
        </div>
        <div class="space"></div>
        @if (configuration.subNavItems?.length > 0) {
        <ul class="footer-sub-nav">
            @for (item of configuration.subNavItems; track item) {
            <li>
                <ng-container
                    *ngTemplateOutlet="navItem; context: { $implicit: item }"
                ></ng-container>
            </li>
            }
        </ul>
        }
    </div>
</div>

<ng-template #navItem let-item>
    @switch (item.type) { @case ('a') {
    <a class="footer-nav-item" href="{{ item.href }}">
        <span>{{ item.content }}</span>
    </a>
    } @case ('a-ng') {
    <a class="footer-nav-item" [routerLink]="item.routerLink">
        <span>{{ item.content }}</span>
    </a>
    } @case ('a-icons') {
    <span class="footer-nav-item">
        <span>{{ item.content }}</span>
        <ul class="footer-social-media">
            @for (icon of item.icons; track icon) {
            <li>
                <a href="{{ icon.href }}">
                    <i class="fa {{ icon.icon }}"></i>
                </a>
            </li>
            }
        </ul>
    </span>
    } @default {
    <span class="footer-nav-item">
        {{ item.content }}
    </span>
    } }
</ng-template>
